import * as React from "react"
import * as Immutable from 'immutable'
import GlobalPeriodPicker from "../../../utils/period_picker/GlobalPeriodPicker";
import { StartEnd } from "../../../utils/period_picker/PeriodPicker";
import { FocusedInputShape } from "react-dates";


export type QuickFilterProps = StartEnd & {
  focusedInput: FocusedInputShape
  onFocusChange: (fi: FocusedInputShape) => void
  onDatesChange: (range: StartEnd) => void
  filterDisabled: boolean
  onFilterSubmit: () => void
  maxPeople: number
  onMaxPeopleChange: (_:number) => void
}

export default (props: QuickFilterProps) : JSX.Element => (
  <form
    className="simple_form search__form"
    onSubmit={(e) => {
      e.preventDefault()
      props.onFilterSubmit()
    }}
  >
    <div className='search__inner date-pickers'>
      <div className='search__col'>
        <div className="input select optional search_max_persons">
          <label className="select optional control-label" htmlFor="search_max_persons">{I18n.t('search.persons_select')}</label>

          <select
            className="input--white"
            placeholder={I18n.t('search.persons_select')}
            value={props.maxPeople}
            disabled={props.filterDisabled}
            onChange={(e) => props.onMaxPeopleChange(parseInt(e.currentTarget.value))}
          >
            <option value={0}>{I18n.t('search.persons_select_placeholder')}</option>
            {Immutable.Range(1,21).map(i => (
              <option key={`people_${i}`} value={i}>{I18n.t('search.persons_count', {count: i})}</option>
            ))}
            <option value={21}>{I18n.t('search.more_than_twenty')}</option>
          </select>
        </div>
      </div>
      <div className='search__col search__col--datepicker'>
        <div className="homepage_datepicker">
          <div>
            <label className="select optional control-label">{I18n.t("rental_adverts.period_picker.from")}</label>
            <label className="select optional control-label">{I18n.t("rental_adverts.period_picker.to")}</label>
          </div>
          <GlobalPeriodPicker
            onDatesChange={(range: StartEnd) => props.onDatesChange(range)}
            startDate={props.startDate}
            endDate={props.endDate}
            disabled={props.filterDisabled}
            onFocusChange={(fi) => props.onFocusChange(fi)}
            focusedInput={props.focusedInput}
          />
        </div>
      </div>
      <div className='search__col search__col--button'>
        <button
          name="button"
          type="submit"
          className="btn search__button"
          data-label={I18n.t('helpers.submit.search.create')}
        />
      </div>
    </div>
  </form>
)
